<div class="card panel-flat-color secondary-panel small-panel mt-4" data-qa="invoice-details-panel">
    <div class="panel-flat-header small-header mb-0">
        <div class="header-icon"><i class="fa fa-info-circle"></i></div>
        <h3>Invoice Details</h3>
        @if (!currentInvoice().isAdHoc) {
            <div class="float-end header-button-container">
                @if (editMode()) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            data-qa="invoice-details-refresh"
                            (click)="refreshCurrentInvoice()">
                        <i class="fa fa-refresh" title="Refresh" style="color: white;"></i>
                    </button>
                }
            </div>
        }
    </div>
    <div class="panel-flat-body">
        @if (currentInvoice()) {
            <div class="invoice-details-grid">
                <div>
                    <tax-savings-details [currentInvoice]="currentInvoice()"
                                         [invoiceForm]="invoiceForm"
                                         (otherParcelsChanged)="otherParcelsChanged($event)">
                    </tax-savings-details>
                </div>
                <div class="invoice-details-summary">
                    <tax-savings-summary [(currentInvoice)]="currentInvoice"
                                         [invoiceForm]="invoiceForm"
                                         [editMode]="editMode()">
                    </tax-savings-summary>
                </div>
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center">
                        <span style="font-weight: bold; margin-right: 10px;">Notes on Invoice:</span>
                        <div class="checkbox">
                            <label>
                                <input type="checkbox"
                                       data-qa="invoice-details-automatically-update-notes"
                                       [disabled]="!editMode()"
                                       [(ngModel)]="currentInvoice().automaticallyUpdateNotes"
                                       (change)="automatedNoteChange()" />
                                Automatically Update
                            </label>
                        </div>
                        @if (!currentInvoice().isAdHoc) {
                            <div style="padding-left: 10px;">
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox"
                                               data-qa="invoice-details-include-tax-savings-worksheet"
                                               [disabled]="!editMode()"
                                               [(ngModel)]="currentInvoice().includeTaxSavingsWorksheet"
                                               (change)="includeTaxSavingsWorksheetChange()" />
                                        Include Tax Savings Worksheet
                                    </label>
                                </div>
                            </div>
                        }
                    </div>
                    <textarea class="form-control"
                              data-qa="invoice-details-notes"
                              style="width: 100%; height: 146px; min-width:20em;"
                              [disabled]="!editMode() || currentInvoice().automaticallyUpdateNotes"
                              [style.color]="currentInvoice().automaticallyUpdateNotes ? 'black' : 'red'"
                              [(ngModel)]="currentInvoice().notes">
                    </textarea>
                </div>
            </div>
        }
    </div>
</div>
